(function () {
    "use strict";

    angular.module("app").controller("PersonScreeningController", PersonController);

    PersonController.$inject = ["$scope", "$rootScope", "$window", "screeningService", "user", "enumService", "IvmScreeningRemarkValidator", "RemarkValidator", "downloadService", "controllerDecorator", "codesService", "habilEnabledFeatures"];
    function PersonController($scope, $rootScope, $window, screeningService, user, enumService, IvmScreeningRemarkValidator, RemarkValidator, downloadService, controllerDecorator, codesService, habilEnabledFeatures) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "files", "navigation"]);

        const ivmStatusCodes = enumService.IvmStatusCodes;

        $scope.isCurrent = () => true;

        $scope.isReadOnly = isReadOnly;
        function isReadOnly() {
            if (!$scope.request || $scope.request.Screenings === undefined || $scope.request.Screenings.length === 0)
                return true;

            const states = [enumService.ScreeningStatusCode.Completed, enumService.ScreeningStatusCode.Stopped, enumService.ScreeningStatusCode.ReadOnly];

            const screeningStatusCode = Number.parseInt($scope.request.CurrentScreening.Status);
            return states.includes(screeningStatusCode);
        }

        function initialize() {
            $scope.InitVars = function () {
                $scope.request = {};

                $scope.ExecutivePartners = [];

                vm.Utils.invoke(codesService.getCodePartnersList, p => $scope.ExecutivePartners = p);

                $scope.requestId = $window.location.search.split('&')[0].replace('?', '').replace('requestId=', '');

                const path = $window.location.pathname.split('/').filter((el) => el.length !== 0);
                const pathpiece = path.length - 1;
                $scope.action = path[pathpiece].toLowerCase();
            };

            $scope.InitFilters = function () {
                $scope.filterForeignVerificationUploaded = function (item) {
                    return item.TypeCode === '141';
                };
                $scope.filterRelations = function (item) {
                    return item.PersonTypeCode !== '10' &&
                        item.PersonTypeCode !== '11' &&
                        item.PersonTypeCode !== '20' &&
                        item.PersonTypeCode !== '21' &&
                        item.PersonTypeCode !== '120' &&
                        item.PersonTypeCode !== '121' &&
                        item.PersonTypeCode !== '170' &&
                        item.PersonTypeCode !== '171' &&
                        !item.IsPartner;
                };
                $scope.filterChildren = function (item) {
                    return (item.PersonTypeCode === '21' ||
                        item.PersonTypeCode === '120' ||
                        item.PersonTypeCode === '121') &&
                        !item.IsPartner;
                };
                $scope.filterRefs = function (item) {
                    return item.PersonTypeCode === '170';
                };
                $scope.filterPartners = function (item) {
                    return item.IsPartner ||
                        item.PersonTypeCode === '10' ||
                        item.PersonTypeCode === '11' ||
                        item.PersonTypeCode === '20' ||
                        item.PersonTypeCode === '171';
                };
                $scope.filterAttachmentContainsExtract = (att) => att.TypeCode === '900';
            };

            $scope.InitVars();
            $scope.InitFilters();

            $scope.DoesItemContainSectionRemark = function (item, section) {
                if (item.Remarks === undefined || item.Remarks === null || item.Remarks.length === 0)
                    return section % 2 !== 0;
                return item.Remarks.some(obj => obj.Section === section);
            };

            $scope.isRequestValidated = () => false;
        }

        initialize();

        $scope.$watch(setButtonStates);

        $scope.$on('actionBar_acceptedClick', () => $scope.SetAsAccepted());
        $scope.$on('actionBar_returnClick', transferRequestInvalid);
        $scope.$on('actionBar_extractClick', () => downloadExtract());
        $scope.$on('actionBar_closeClick', function () {
            removeUnloadEvent();
            vm.Navigator.GoToDashboard();
        });

        function prepareData() {
            // Needed Checks
            if ($scope.request.PersonData.Nationalities === undefined || $scope.request.PersonData.Nationalities.length === 0) {
                $scope.request.PersonData.Nationalities = [{}];
            }

            const states = [ivmStatusCodes.Accepted, ivmStatusCodes.AcceptedWithLimitation, ivmStatusCodes.Signed, ivmStatusCodes.SignedWithLimitation];

            if (states.includes($scope.request.Status)) {
                $scope.request.Limited = true;
            }

            vm.SetLoadingState(false);
        }

        function loadIVM() {
            vm.SetLoadingState(true);

            vm.Api.GetIVMRequestPhase5(
                { RequestId: $scope.requestId },
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.request = result.data;
                        $scope.organisationId = result.data.DossierOrganisationPublicId;

                        determineInteractionLevel();

                        getRemarks();

                        vm.Comments.Initialize({ RequestId: $scope.request.PublicId, OrganisationId: $scope.organisationId, ICD: $scope.request.ScreeningBy });

                        if ($scope.request.CreatedByFVM) {
                            vm.Api.GetIVMScreeningRemarks({ PublicId: $scope.request.PublicId }, (r) => {
                                if (CheckResultReceived(r)) {
                                    $scope.ScreeningRemarks = r.data;
                                }
                                else {
                                    vm.ShowError(r);
                                }
                            });
                        }

                        prepareData();
                    }
                    else { vm.ShowError(result); }
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function getRemarks() {
            vm.Api.GetRemarksForPscRequest(
                { RequestId: $scope.request.PublicId },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    $scope.otherRemarks = result.data.OtherRemarks;
                },
                vm.ShowError
            );
        }

        $scope.SetAsAccepted = function () {
            vm.SetLoadingState(true);

            screeningService.setAsAccepted($scope.request.CurrentScreening.PublicId,
                function () {
                    removeUnloadEvent();

                    vm.Navigator.ReturnToPreviousPage();
                },
                (error) => {
                    vm.ShowError(error);
                    vm.SetLoadingState(false);
                });

        };

        function downloadExtract() {
            vm.SetLoadingState(true);

            vm.Api.GetPhaseFile(`id=${$scope.request.CurrentScreening.PublicId}`)
                .then(vm.File.Save, vm.ShowError)
                .catch(vm.ShowError)
                .finally(() => {
                    determineInteractionLevel(true);
                    vm.SetLoadingState(false);
                });
        }

        function determineInteractionLevel(canAccept) {
            if (canInteractWithPersons()) {
                $rootScope.$broadcast('request_buttonVisibilityChange', $scope.request.CurrentScreening.Status === '10' && ($scope.request.Attachments.filter($scope.filterAttachmentContainsExtract).length !== 0 || canAccept), false);
                $rootScope.$broadcast('request_stateChangedTo', $scope.request.CurrentScreening.Status !== '40');
            }
        }

        $scope.PersonsThatNeedToSign = personsThatNeedToSign;
        function personsThatNeedToSign() {
            if (!$scope.request || !$scope.request.RequestIVMRelatedPersonList)
                return [];

            return $scope.request.RequestIVMRelatedPersonList.filter(function (r) {
                return (r !== null && r.PersonData && r.PersonData.NeedsSigning) ? r : null;
            });
        }

        function transferRequestInvalid() {
            vm.SetLoadingState(true);

            vm.Api.SendIvmBackInvalidByCol(
                { Request: $scope.request },
                (result) => {
                    if (CheckResultReceived(result)) {
                        vm.ShowSuccess(vm.getTranslation("Person_YourRequestHasBeenTransferred"));
                        removeUnloadEvent();

                        vm.Navigator.ReturnToPreviousPage();
                    }
                    else { vm.ShowError(result); }
                },
                vm.ShowError,
                () => vm.SetLoadingState(false));
        }

        $scope.SetErrorMessages = function () {
            $scope.msg = vm.getTranslation("Form_Error_Validation") + ": <ul>";
            $scope.notiTab = false;
            $scope.idenTab = false;
            $scope.natiTab = false;
            $scope.civsTab = false;
            $scope.addrTab = false;
            $scope.walkTab = false;
            $scope.partTab = false;
            $scope.roofTab = false;
            $scope.refsTab = false;
            $scope.actiTab = false;
            $scope.justiTab = false;

            _.forEach($scope.requestForm.$error, function (n, key) {
                showError(n, key, $scope.requestForm, $scope.msg);
            });

            if ($scope.notiTab) { $scope.msg += createTabErrorItem("Person_Notification_Tab"); }
            if ($scope.idenTab) { $scope.msg += createTabErrorItem("Person_Identity_Tab"); }
            if ($scope.natiTab) { $scope.msg += createTabErrorItem("Person_Nationality_Tab"); }
            if ($scope.civsTab) { $scope.msg += createTabErrorItem("Person_CivilStatus_Tab"); }
            if ($scope.addrTab) { $scope.msg += createTabErrorItem("Person_Address_Tab"); }
            if ($scope.walkTab) { $scope.msg += createTabErrorItem("Person_WalkofLive_Tab"); }
            if ($scope.partTab) { $scope.msg += createTabErrorItem("Person_Partner_Tab"); }
            if ($scope.roofTab) { $scope.msg += createTabErrorItem("Person_Roof_Tab"); }
            if ($scope.refsTab) { $scope.msg += createTabErrorItem("Person_Refs_Tab"); }
            if ($scope.actiTab) { $scope.msg += createTabErrorItem("Person_Actions_Tab"); }
            if ($scope.justiTab) { $scope.msg += createTabErrorItem("Person_Justification_Tab"); }

            $scope.msg += "</ul>";

            if ($scope.msg === vm.getTranslation("Form_Error_Validation") + ": <ul></ul>") {
                return false;
            }
            return true;

            function createTabErrorItem(tabNameKey) {
                return "<li>" + vm.getTranslation("Form_Error_OnTab") + vm.getTranslation(tabNameKey) + "</li>";
            }
        };

        loadIVM();

        function showError(n, key, formlist, msg) {
            const validation = key;
            _.forEach(n, function (n1) {
                if (n1.$name !== '') {
                    if (n1.$name === 'userFieldForm' || n1.$name === 'NationalityForm' || n1.$name === 'AttachFieldForm' || n1.$name === 'CivilStateForm') {
                        _.forEach(n1.$error, function (n2, key2) {
                            showError(n2, key2, n1, msg);
                        });
                    }
                    else if (n1.$name.indexOf('Nationality_Person_PersonData_') >= 0) { $scope.natiTab = true; }
                    else if (n1.$name.indexOf('Person_PersonData_Noti_') >= 0) { $scope.notiTab = true; }
                    else if (n1.$name.indexOf('MyNationality_') >= 0) { $scope.natiTab = true; }
                    else if (n1.$name.indexOf('MyCivilState_') >= 0) { $scope.civsTab = true; }
                    else if (n1.$name.indexOf('CivilStatus_Person_PersonData_') >= 0) { $scope.civsTab = true; }
                    else if (n1.$name.indexOf('Address_Person_PersonData') >= 0) { $scope.addrTab = true; }
                    else if (n1.$name.indexOf('WalkofLive_Person_PersonData') >= 0) { $scope.walkTab = true; }
                    else if (n1.$name.indexOf('Ref_Person_PersonData') >= 0) { $scope.refsTab = true; }
                    else if (n1.$name.indexOf('Partner_Person_PersonData') >= 0) { $scope.partTab = true; }
                    else if (n1.$name.indexOf('Nationality_Partner_Person_PersonData') >= 0) { $scope.partTab = true; }
                    else if (n1.$name.indexOf('Nationality_Roof_Person_PersonData') >= 0) { $scope.roofTab = true; }
                    else if (n1.$name.indexOf('Roof_Person_PersonData') >= 0) { $scope.roofTab = true; }
                    else if (n1.$name.indexOf('Action_Person_PersonData') >= 0) { $scope.actiTab = true; }
                    else if (n1.$name.indexOf('Person_Justification_Validation') >= 0) { $scope.justiTab = true; }

                    else if (n1.$name.indexOf('Person_PersonData') >= 0) { $scope.idenTab = true; }
                    else { msg += '<li>' + n1.$name + ' (' + validation + ')</li>'; }
                    try {
                        formlist[n1.$name].$setDirty();
                    }
                    catch {
                        // Don't do anything.
                    }
                }
            });
        }

        $scope.DownloadHabilBVL = function (bvl) {
            vm.SetLoadingState(true);
            downloadService.DownloadBVL(bvl, () => vm.SetLoadingState(false));
        };

        $scope.GetHabilMigrationCertificate = function (bvl) {
            vm.SetLoadingState(true);
            downloadService.DownloadCertificate(bvl, () => vm.SetLoadingState(false));
        };

        function canInteractWithPersons() {
            if ($scope.request.Screenings.length === 0)
                return;

            const screeningStatusCode = Number.parseInt($scope.request.CurrentScreening.Status);
            if (user.WorksForPartner != enumService.ScreeningServices.FODECO && user.WorksForPartner != '' && screeningStatusCode !== enumService.ScreeningStatusCode.Stopped) {
                $rootScope.$broadcast('request_CanInteractWithPersons', true);
                return true;
            }

            $rootScope.$broadcast('request_CanInteractWithPersons', false);
            return false;
        }

        //#region Unload handler

        function addUnloadEvent() {
            if ($window.addEventListener) {
                $window.addEventListener('beforeunload', handleUnloadEvent);
            } else {
                //For IE browsers
                $window.attachEvent('onbeforeunload', handleUnloadEvent);
            }
        }
        function handleUnloadEvent(event) {
            if ($scope.requestForm.$dirty) {
                event.returnValue = $scope.translations.CloseReloadWarningText;
            }
        }

        //Call this when you want to remove the event, example, if users fills necessary info
        function removeUnloadEvent() {
            if ($window.removeEventListener) {
                $window.removeEventListener('beforeunload', handleUnloadEvent);
            } else {
                $window.detachEvent('onbeforeunload', handleUnloadEvent);
            }
        }
        addUnloadEvent();

        //#endregion

        $scope.OpenRequestInNewWindow = function (requestId) {
            vm.Navigator.OpenIvmViewOnly(requestId, true);
        };

        $scope.onValidateRemark = onValidateRemark;
        function onValidateRemark(_value, _object, _id, remark) {
            if (!$scope.request.CreatedByFVM && remark) {
                vm.Api.SaveRequestRemark(
                    {
                        RequestId: $scope.request.PublicId,
                        Remark: remark
                    },
                    (result) => {
                        if (!CheckResultReceived(result)) {
                            vm.ShowError(result);
                        }
                    },
                    vm.ShowError
                );
            }

            setButtonStates();
        }

        /**
         * Updates the Accept and Retour buttons in the action bar.
         */
        function setButtonStates() {
            if (isReadOnly()) {
                $rootScope.$broadcast('request_stateCanReturn', false);
                return;
            }

            let canReturn = false;
            let canAccept = false;

            if ($scope.request.CreatedByFVM) {
                canReturn = IvmScreeningRemarkValidator.HasInvalidRemark($scope.ScreeningRemarks);
                canAccept = !canReturn;
            }
            else {
                const hasInvalid = RemarkValidator.IndividualRequestHasInvalidRemarks($scope.request);
                canReturn = hasInvalid && !RemarkValidator.IndividualRequestHasInvalidRemarksWithoutReason($scope.request);
                canAccept = !hasInvalid;
            }

            // TODO: canAccept
            $rootScope.$broadcast('request_stateCanAccept', canAccept);
            $rootScope.$broadcast('request_stateCanReturn', canReturn);
        }

        $scope.ContainsRemark = containsRemark;
        function containsRemarkWithSectionCode(sectionCode) {
            if (!$scope.request.Remarks)
                return false;

            return $scope.request.Remarks.some(r => r.Section === sectionCode);
        }

        $scope.ShouldCheckBVL = shouldCheckBVL;
        function shouldCheckBVL() {
            if (!$scope.request?.Attachments)
                return false;

            const involvedDidNotSign = !$scope.request.PersonData.Signature;
            const otherPersonDidNotSign = $scope.request.RequestIVMRelatedPersonList.some(p => p?.PersonData?.NeedsSigning && !p.PersonData.Signature);

            return (involvedDidNotSign || otherPersonDidNotSign) && $scope.request.Attachments.some(a => a.TypeCode === '101');
        }

        $scope.GoToAttachments = goToAttachments;
        function goToAttachments(anchor) {
            const target = $(anchor);
            $('html,body').animate({ scrollTop: target.offset().top - 50 });
        }

        $scope.SaveRemark = vm.Api.SaveIVMScreeningRemark;

        const ivmSectionNameToInvalidRemarkMap = {
            Justification: '191',
            Identity: '201',
            Nationality: '211',
            CivilStatus: '221',
            Partner: '231',
            Address: '241',
            WalkOfLife: '251',
            Roof: '261',
            Children: '267',
            References: '271',
            Signature: '669',
            Attachments: '277'
        };

        function containsRemark(sectionIdentifier) {
            if (!$scope.request || !sectionIdentifier)
                return false;

            if ($scope.request.CreatedByFVM) {
                return IvmScreeningRemarkValidator.HasInvalidRemarkForSection($scope.ScreeningRemarks, sectionIdentifier);
            }
            else {
                for (let [key, value] of Object.entries(ivmSectionNameToInvalidRemarkMap)) {
                    if (key.toLowerCase() == sectionIdentifier.toLowerCase())
                        return containsRemarkWithSectionCode(value);
                }
            }

            return false;
        }

        $scope.HasForeignVerificationFiles = hasForeignVerificationFiles;
        function hasForeignVerificationFiles() {
            if (!$scope.request)
                return false;
            return $scope.request.Attachments.filter($scope.filterForeignVerificationUploaded).length > 0;
        }

        $scope.IsAdviceScreening = isAdviceScreening;
        function isAdviceScreening() {
            if (!$scope.request || !$scope.request.CurrentScreening)
                return;

            if ($scope.request.CurrentScreening.TypeCode == enumService.ScreeningTypeCode.SecurityCheck)
                return $scope.translations.InitialAction_Check;
        }

        $scope.GetScreeningRowStyle = getScreeningRowStyle;
        function getScreeningRowStyle(screening) {
            const partners = [enumService.ScreeningServices.VSSE, enumService.ScreeningServices.ADIVSGRS];

            if (!partners.includes(screening.DoneBy)) {
                if (screening.TypeCode === enumService.ScreeningTypeCode.CertificateOut) return "bg-Foreign";

                const momentScreeningSendDateLimit = moment(screening.ScreeningSendDate).startOf("day").add(3, "M");
                const today = moment().startOf("day");

                if (today.isSameOrBefore(momentScreeningSendDateLimit)) return "bg-Foreign";
                if (today.isAfter(momentScreeningSendDateLimit)) return "screeningOutOfTimeLimit";
            }

            const screeningState = Number.parseInt(screening.Status);
            if (screeningState >= enumService.ScreeningStatusCode.Completed) return "bg-success";
        }

        $scope.hasNonforeignScreenings = hasNonforeignScreenings;
        $scope.GetScreeningReports = getScreeningReports;
        $scope.GetForeignScreeningReports = getForeignScreeningReports;

        const cache = {
            screeningReports: null,
            foreignScreeningReports: null
        };

        function hasNonforeignScreenings(request) {
            return request.Screenings?.some(s => !s.IsForeign);
        }

        function getScreeningReports() {
            if (Array.isArray(cache.screeningReports)) {
                return cache.screeningReports;
            }

            const nonforeignScreenings = $scope.request?.Screenings?.filter(s => !s.IsForeign) ?? [];

            if (!nonforeignScreenings.length) {
                return [];
            }

            cache.screeningReports = nonforeignScreenings.flatMap(s => s.Attachments.filter(a => a.TypeCode == enumService.AttachmentTypes.ScreeningResultDocument));

            return cache.screeningReports;
        }

        function getForeignScreeningReports() {
            if (Array.isArray(cache.foreignScreeningReports)) {
                return cache.foreignScreeningReports;
            }

            if (!$scope.request?.ForeignScreenings?.length) {
                return [];
            }

            cache.foreignScreeningReports = $scope.request.ForeignScreenings.flatMap(s => s.Attachments.filter(a => a.TypeCode == enumService.AttachmentTypes.ScreeningResultDocument));

            return cache.foreignScreeningReports;
        }

        $scope.hasScreeningAttachments = hasScreeningAttachments;
        function hasScreeningAttachments(request) {
            return !!request.Screenings?.some(s => !!s.Attachments?.length);
        }

        $scope.IsPayrollConsultantFeatureEnabled = isPayrollConsultantFeatureEnabled;
        function isPayrollConsultantFeatureEnabled() {
            if (!$scope.request || $scope.request.CreatedByFVM)
                return false;

            const ivmPayrollConsultant = "IVM_PAYROLL_CONSULTANT";
            return habilEnabledFeatures.some(f => f == ivmPayrollConsultant);
        }
    }
})();
